module.exports = __webpack_public_path__ + "img/logo.763e2a6b.png";